"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<33458554d110f8c8f93206eb893f2618>>
 *
 * Generated by CLDRGenScript
 *
 * 
 */
var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType23 = {
  getVariation: function getVariation(n) {
    if (n % 100 === 1) {
      return IntlVariations.NUMBER_ONE;
    } else if (n % 100 === 2) {
      return IntlVariations.NUMBER_TWO;
    } else if (n % 100 >= 3 && n % 100 <= 4) {
      return IntlVariations.NUMBER_FEW;
    } else {
      return IntlVariations.NUMBER_OTHER;
    }
  }
};
module.exports = IntlCLDRNumberType23;